import { DATAGRID_TABLE_CELL_WIDTH } from '../../../../utils/constants';

const parametriTablecColumns = (renderParameterDropdownCell, RenderValueCell, renderActions, updateData, setIsDirtyForId) => [
  {
    field: 'parameter',
    headerName: 'Parameter',
    flex: 1,
    minWidth: DATAGRID_TABLE_CELL_WIDTH.MINWIDTH,
    maxWidth: DATAGRID_TABLE_CELL_WIDTH.MAXWIDTH,
    headerAlign: 'center',
    align: 'center',
    renderCell: renderParameterDropdownCell
  },
  {
    field: 'value',
    headerName: 'Values',
    width: 700,
    headerAlign: 'center',
    align: 'center',
    renderCell: (params) => <RenderValueCell row={params.row} updateData={updateData} setIsDirtyForId={setIsDirtyForId} params={params} />,
  },
  {
    field: 'actions',
    headerName: 'Actions',
    flex: 1,
    minWidth: DATAGRID_TABLE_CELL_WIDTH.MINWIDTH,
    maxWidth: DATAGRID_TABLE_CELL_WIDTH.MAXWIDTH,
    headerAlign: 'center',
    align: 'center',
    renderCell: renderActions,
  }
];

export { parametriTablecColumns };
